import { BreadcrumbItem } from '@/components/Breadcrumb/breadcrumb.model'

/**
 * Removes specific breadcrumb items ("API Products" and "Products") from the list.
 *
 * @param items - The list of breadcrumb items.
 * @returns A filtered list of breadcrumb items.
 */
export function removeProductsFromBreadcrumbs(
  items: BreadcrumbItem[]
): BreadcrumbItem[] {
  const API_PRODUCTS_TEXT = 'api products'
  const PRODUCTS_TEXT = 'products'

  const apiProductsIndex = items.findIndex(
    (item) => item.text.toLowerCase() === API_PRODUCTS_TEXT
  )
  if (apiProductsIndex !== -1) {
    items.splice(apiProductsIndex, items.length - apiProductsIndex)
  }

  const productsIndex = items.findIndex(
    (item) => item.text.toLowerCase() === PRODUCTS_TEXT
  )
  if (productsIndex !== -1) {
    items.splice(productsIndex, 1)
  }

  return items
}